import request from '@/utils/request';

// 获取最近发布期
export function getLatelyPubDate() {
    return request({
        url: '/design/getLatelyPubDate',
        method: 'get'
    });
}

// 获取上一个发布期
export function getLastPubdate(params) {
    return request({
        url: '/design/getLastPubdate',
        method: 'get',
        params
    });
}

// 获取最近发布期
export function getNearPub() {
    return request({
        url: '/design/getNearPub',
        method: 'get'
    });
}

// 根据传入时间获取最近发布期
export function getPubByDate(params) {
    return request({
        url: '/design/getPubByDate',
        method: 'get',
        params
    });
}

// 检查日期是否是发布期
export function checkPublicdate(params) {
    return request({
        url: '/design/checkPublicdate',
        method: 'get',
        params
    });
}

// 是否为自己下级
export function checkOperator(params) {
    return request({
        url: '/purchaseContract/checkOperator',
        method: 'get',
        hiddenPopup: true,
        params
    });
}

// 获取员工的部门列表
export function getEmpDeptList(params) {
    return request({
        url: '/employee/getEmpDeptList',
        method: 'get',
        params
    });
}

// 获取服务器时间
export function getSysTime(params) {
    return request({
        url: '/employee/getSysTime',
        method: 'get',
        hiddenPopup: true,
        params
    });
}

// 公司账户
export function bankList(params) {
    return request({
        url: '/bank/list',
        method: 'get',
        params
    });
}

// 获取模块是否有审批流程
export function checkAuditSteps(moduleName, params) {
    const apis = {
        'sellContract': 'sellContract/checkAuditSteps', // 1是销售合同  2是变更  3是作废
        'sellContractOn': 'sellContractOn/checkAuditSteps', // 1是销售合同  2是变更  3是作废 4是续费
        'purchaseContract': 'purchaseContract/checkAuditSteps',
        'outsourceContract': 'outsourceContract/checkAuditSteps',
        'outsourceContractOn': 'outsourceContractOn/checkAuditSteps', // 1是合同审核  2是变更  3是作废
        'brand': 'brand/checkAuditSteps',
        'purchaseContractPay': 'purchaseContractPay/checkAuditSteps',
        'installWork': 'installWork/checkAuditSteps',
        'removeWork': 'removeWork/checkAuditSteps',
        'generalContract': 'commonContract/checkAuditSteps'

    };
    return request({
        url: apis[moduleName],
        method: 'get',
        hiddenPopup: true,
        params
    });
}

// 导出社区-获取字段排序
export function getField(params) {
    return request({
        url: '/exportField/getField',
        method: 'get',
        params
    });
}

// 导出社区-获取字段排序
export function getFieldByType(params) {
    return request({
        url: '/exportField/getFieldByType',
        method: 'get',
        params
    });
}

// 导出社区-保存字段排序
export function saveField(params) {
    return request({
        url: '/exportField/saveField',
        method: 'get',
        params
    });
}

// 所有商圈
export function circleList(params) {
    return request({
        url: '/circle/selectList',
        method: 'get',
        params
    });
}

// 通过城市获取商圈
export function listByCityStr(params) {
    return request({
        url: '/circle/listByCityStr',
        method: 'get',
        params
    });
}

// 媒体类型-本公司
export function mediaList(params) {
    return request({
        url: '/csmedium/haveMediumTypeList',
        method: 'get',
        params
    });
}
